import React, { useMemo, useState } from "react";
import { Search } from "lucide-react";
import { SectionHeading } from "../../components/ui/SectionHeading";
import { ActivityCard } from "../../components/ui/ActivityCard";
import { CloudsLayer } from "../../components/ui/Decorations";
import { EmptyState } from "../../components/ui/EmptyState";
import { useApp } from "../../context/AppContext";
import { ACTIVITY_CATEGORIES } from "../../data/mockData";
import { cn } from "../../lib/utils";

export default function Activities() {
  const { activities, activityStatus } = useApp();
  const [filter, setFilter] = useState("all");
  const [q, setQ] = useState("");

  const filtered = useMemo(() => {
    return activities.filter((a) => {
      if (q && !a.name.toLowerCase().includes(q.toLowerCase())) return false;
      if (filter === "all") return true;
      if (filter === "available") {
        const s = activityStatus(a);
        return s === "available" || s === "almost-full";
      }
      return a.category === filter;
    });
  }, [activities, filter, q, activityStatus]);

  return (
    <div>
      <section className="relative overflow-hidden pt-10 pb-4">
        <CloudsLayer />
        <div className="max-w-6xl mx-auto px-4 text-center relative z-10">
          <SectionHeading eyebrow="Activities" title="Pilih Keseruanmu!" subtitle="Jelajahi semua aktivitas. Beberapa perlu reservasi, sisanya bebas datang kapan saja." />
        </div>
      </section>

      <section className="pb-20">
        <div className="max-w-7xl mx-auto px-4">
          {/* controls */}
          <div className="flex flex-col md:flex-row md:items-center gap-4 mb-8">
            <div className="flex flex-wrap gap-2">
              {ACTIVITY_CATEGORIES.map((c) => (
                <button
                  key={c.value}
                  onClick={() => setFilter(c.value)}
                  data-testid={`filter-${c.value}`}
                  className={cn(
                    "px-4 py-2 rounded-full font-display text-sm border-2 transition-colors",
                    filter === c.value ? "bg-coral text-white border-coral" : "bg-white text-sea-deep border-white hover:bg-sky/15"
                  )}
                >
                  {c.label}
                </button>
              ))}
            </div>
            <div className="md:ml-auto relative">
              <Search className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-sea-deep/40" />
              <input
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="Cari aktivitas..."
                data-testid="activity-search"
                className="pl-10 pr-4 py-3 rounded-full border-2 border-white shadow-playful outline-none focus:border-sky-dark font-semibold text-sea-deep w-full md:w-64"
              />
            </div>
          </div>

          {filtered.length ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {filtered.map((a, i) => <ActivityCard key={a.id} activity={a} index={i} />)}
            </div>
          ) : (
            <EmptyState
              title="Tidak ada aktivitas ditemukan"
              message="Coba ubah filter atau kata pencarianmu ya."
              ctaLabel="Reset Filter"
              onCta={() => { setFilter("all"); setQ(""); }}
            />
          )}
        </div>
      </section>
    </div>
  );
}
